import { themeVars, nToPx } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const confirmModalContainerClass = style({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  maxWidth: 650,
});

export const confirmModalContentClass = style({
  width: '100%',
  minWidth: 500,
  fontSize: themeVars.font.size.textLg,
});

export const confirmModalContentDisclaimerClass = style({
  margin: nToPx(themeVars.space.x6, 0, themeVars.space.x4),
});
